import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "collection" }
const _hoisted_2 = { class: "collectionList flex flex-wrap gap-4px justify-between" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "name w-[132px] flex justify-between mt-[10px]" }
const _hoisted_6 = { class: "text-ellipsis whitespace-nowrap overflow-hidden w-[102px] text-[12px]" }
const _hoisted_7 = { class: "text-[12px] text-[#808080]" }

import { onMounted, ref } from 'vue'
import { getCollectionPages } from '@/api/affairs'


export default /*@__PURE__*/_defineComponent({
  __name: 'collectList',
  props: {
  showNum: {
    type: Number,
    default: 4
  },
  searchkwords: {
    type: String,
    default: ''
  }
},
  emits: ["selectMore", "num"],
  setup(__props, { emit: __emit }) {

const props = __props


const collectionList = ref([])
const emit = __emit
const handleMoreClick = (item) => {
  console.log(item)
  emit('selectMore', item)
}
onMounted(() => {
  getCollectionPages({ page: 1, size: props.showNum ? props.showNum : 10, name: props.searchkwords }).then(res => {
    if (res.data?.data?.items) {
      collectionList.value = res.data?.data?.items
      emit('num', collectionList.value.length)
    }
  })
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collectionList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "sorting border-box mb-[10px] cursor-pointer",
          key: index
        }, [
          _createElementVNode("div", {
            class: "list flex flex-wrap gap-10px w-[132px] justify-between p-10px bg-[#f8f8fb] rounded-md pb-[0px] hover:bg-[#e8e8ed]",
            style: {"border-radius":"8px"},
            onClick: ($event: any) => (handleMoreClick(item))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.materials.slice(0, 4), (items, indexs) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "img w-[50px] h-[50px] rounded-md overflow-hidden mb-[10px]",
                key: indexs
              }, [
                _createElementVNode("img", {
                  src: items.preview_url_small,
                  alt: ""
                }, null, 8, _hoisted_4)
              ]))
            }), 128))
          ], 8, _hoisted_3),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.materials_count) + "张", 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})